import { css } from 'styled-components';
import { PURPLE_TEXT } from '../../../constants/colors';
import { media } from '../../../helpers/mixins';

export default {
  featuretextwrapper: css`
    ${media.sm`
       padding: 4.5vw 0px 6vw 0px;
    `};
    ${media.md`
      padding: 45px 0px 60px 0px;
    `};
  `,
  stepswrapper: ({ isPurple }) => css`
    ${media.sm`
       padding: 2vw 0px 2vw 0px;
    `};
    ${media.md`
      padding: 5px 0px 5px 0px;
    `};

    ${isPurple && css`
      background-color: #F3F2F5;
      ${media.sm`
          padding: 2vw 0px;
      `};
      ${media.md`
        padding: 0px 0px;
      `};
    `}

  `
};
